// Floors for the winback panes, which size themselves by subtracting chrome
// from the viewport. A negative height is rejected by the CSSOM, leaving the box
// at `height: auto`: with `overflow: scroll` that is a pane with no scrollbar
// and no bound on its contents.

// Roughly one conversation card; the list's loading skeleton is 150px.
export const MIN_LIST_HEIGHT = 160

// Enough of the customer panel to be worth opening; it scrolls past this.
export const MIN_DETAILS_HEIGHT = 160

// MessageList and TimelineWrapper must floor against the same number: the reply
// box sits at the bottom only while the pane is at least as tall as the timeline
// plus the box.
export const MIN_TIMELINE_HEIGHT = 120
